import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { ReactComponent as NormalCheckbox } from '../../../assets/images/checkbox/normal-checkbox.svg'
import { ReactComponent as ActiveCheckbox } from '../../../assets/images/checkbox/active-checkbox.svg'

function Checkbox({ value, label, onChange }) {
  return (
    <label className={clsx('checkbox', {'checkbox_is-checked': value})}>
      <input
        type="checkbox"
        checked={value}
        onChange={onChange}
      />
      <span className="checkbox__icon">
        {value ? <ActiveCheckbox /> : <NormalCheckbox />}
      </span>
      {label && <span className="checkbox__label">{label}</span>}
    </label>
  )
}

Checkbox.defaultProps = {
  label: ''
}

Checkbox.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string
}

export default React.memo(Checkbox)
